// One h1 sentence for the crawler; the span only sets the smaller second line.
const heroTitle =
	'Imóveis nos Melhores Endereços <span class="mt-1 block text-[24px] leading-[150%] lg:text-[32px]">de São Paulo e Curitiba</span>';

export default {
	en: {},
	pt: {
		// mobile only survives for HeroDeprecated; both read one constant so they cannot drift.
		title: {
			mobile: heroTitle,
			desktop: heroTitle
		},
		titleOnTempHeroMessage: {
			mobile: 'O endereço dos melhores endereços.<br/>Agora em Curitiba.',
			desktop: 'O endereço dos melhores endereços.<br/>Agora em Curitiba.'
		}
	}
};
